import { render, staticRenderFns } from "./AdjustTax.vue?vue&type=template&id=3bf4f0be"
import script from "./AdjustTax.vue?vue&type=script&lang=js"
export * from "./AdjustTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports